import _ from 'lodash'
import { formatItem, formatTypes, getFormattedDate } from "../../../../global/common/dateFormatting"
import { matchScheduleTypes } from "../contexts/SportsSeasonContext"
import { matchDisplayTypes } from './SportsMatchReducer'

const rts = {
  handleMatches_initPlayoff: 'handleMatches_initPlayoff',
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sportsSeasonMatches season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const playoffMatchesReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleMatches_initPlayoff:
      return { ...state, pools: action.pools, poolMatches: action.poolMatches }

    default:
      return { ...state }
  }
}

export const playoffMatchesHandlers = (dispatch) => {
  return {
    handleMatches_initPlayoff: (pools, poolMatches) => { dispatch({ type: rts.handleMatches_initPlayoff, dispatch, pools, poolMatches }) },
  }
}

export const playoffMatchesInitialState = (init_state) => {
  return { ...init_state }
};
